import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminProductsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('product');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
